<template>
  <div class="edit-studio-container">

    <main class="tab-content">

      <h2 class="item text-secondary">Footer content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec">
          <label>Title:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.header" />
        </div>
        <div class="field-sec">
        </div>
        <div class="field-sec membership">
          <label>Membership table:</label>
          <div class="field-sec flex array-links membership" v-for="item, i in fit20.blockToEdit.loop_content ">
            <div class="field-sec flex array-links" v-if="i == 0">
              <div class="field-sec">
                <label>Column1 row{{ i + 1 }} text:</label>
                <input type="text" class="form-control" v-model="item.content1" />
              </div>
              <div class="field-sec">
                <label>Column2 row{{ i + 1 }} text:</label>
                <input type="text" class="form-control" v-model="item.content2.text" />
                <label>Column2 row{{ i + 1 }} price:</label>
                <input type="text" class="form-control" v-model="item.content2.price" />
              </div>
              <div class="field-sec">
                <label>Column3 row{{ i + 1 }} text:</label>
                <input type="text" class="form-control" v-model="item.content3.text" />
                <label>Column3 row{{ i + 1 }} price:</label>
                <input type="text" class="form-control" v-model="item.content3.price" />
              </div>
              <div class="field-sec">
                <label>Column4 row{{ i + 1 }} text:</label>
                <input type="text" class="form-control" v-model="item.content4.text" />
                <label>Column4 row{{ i + 1 }} price:</label>
                <input type="text" class="form-control" v-model="item.content4.price" />
              </div>
            </div>
            <div class="field-sec flex array-links membership" v-if="i != 0 && i != 6">
              <div class="field-sec">
                <label>Column1 row{{ i + 1 }} text:</label>
                <input type="text" class="form-control" v-model="item.content1" />
              </div>
              <div class="field-sec">
                <label>Column2 row{{ i + 1 }}:</label>
                <select v-model="item.content2"
                  :class="{ 'yes-class': item.content2 === 'check', 'no-class': item.content2 === 'x' }">
                  <option value="check">Yes</option>
                  <option value="x">No</option>
                </select>
              </div>
              <div class="field-sec">
                <label>Column3 row{{ i + 1 }} :</label>
                <select v-model="item.content3"
                  :class="{ 'yes-class': item.content3 === 'check', 'no-class': item.content3 === 'x' }">
                  <option value="check">Yes</option>
                  <option value="x">No</option>
                </select>
              </div>
              <div class="field-sec">
                <label>Column4 row{{ i + 1 }}:</label>
                <select v-model="item.content4"
                  :class="{ 'yes-class': item.content4 === 'check', 'no-class': item.content4 === 'x' }">
                  <option value="check">Yes</option>
                  <option value="x">No</option>
                </select>
              </div>
            </div>

            <div class="field-sec" v-if="i == 6">
              <label> free try button text:</label>
              <input type="text" class="form-control" v-model="item.content2.try_free" />
              <label>free try button link:</label>
              <input type="text" class="form-control" v-model="item.content2.link" />
            </div>

          </div>
        </div>
        <div class="field-sec">
          <label>Footer text1:</label>
          <textarea type="text" class="form-control membership-textarea" v-model="fit20.blockToEdit.text1"></textarea>
        </div>
        <div class="field-sec">
          <label>Footer text2:</label>
          <textarea type="text" class="form-control membership-textarea" v-model="fit20.blockToEdit.text2"></textarea>
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is for testing the content but may not be functional:
      <br>

      <div class="memberships-container not-fixed">
        <h2 id="memberships_header">{{ fit20.blockToEdit.header }}</h2>
        <div class="memberships-sec">
          <div id="memberships_table" class="memberships-table-sec">
            <div :class="[
              fit20.selectTabId == '/usa/'
                ? 'memberships-first-row  margin-top'
                : 'memberships-first-row'
            ]">
              <div class=" memberships-first-colum memberships-first-text not-fixed">{{
                fit20.blockToEdit.loop_content[0].content1
              }} </div>
              <div class="memberships-row-fields memberships-first-row-fields not-fixed">
                <div class="membership-first-row-icons-sec not-fixed">
                  <div>{{
                    fit20.blockToEdit.loop_content[0].content2.text
                  }}</div>
                </div>
                <div class="memberships-price stronger ${
      newMembershipsStaticContent.usa ? 'usa-font-size' : ''
    }">{{ fit20.blockToEdit.loop_content[0].content2.price }}</div>
              </div>
              <div class="memberships-row-fields memberships-first-row-fields not-fixed">
                <div class="membership-first-row-icons-sec not-fixed mid-first">
                  <div>{{
                    fit20.blockToEdit.loop_content[0].content3.text
                  }}</div>
                </div>
                <div class="memberships-price stronger ${
      newMembershipsStaticContent.usa ? 'usa-font-size' : ''
    }">{{ fit20.blockToEdit.loop_content[0].content3.price }}</div>
              </div>
              <div class="memberships-row-fields memberships-first-row-fields not-fixed">
                <div class="membership-first-row-icons-sec not-fixed">
                  <div>{{
                    fit20.blockToEdit.loop_content[0].content4.text
                  }}</div>
                </div>
                <div class="memberships-price stronger ${
      newMembershipsStaticContent.usa ? 'usa-font-size' : ''
    }">{{ fit20.blockToEdit.loop_content[0].content4.price }}</div>
              </div>
            </div>
          </div>


          <div v-for="ele, index in fit20.blockToEdit.loop_content.slice(1)" class="memberships-rows not-fixed ">
            <div :class="[
              'memberships' + index
              , 'memberships-row-fields', 'memberships-first-colum']">{{ ele.content1 }} </div>
            <div :class="['memberships' + index,
            ele.content2 == 'x' ? '' : 'checked',
              'memberships-row-fields', 'not-fixed']">
              <img v-if="ele.content2 == 'check' || ele.content2 == 'x'"
                :src="ele.content2 == 'check' ? checkImg : xImg" />
            </div>
            <div :class="['memberships' + index,
            ele.content3 == 'x' ? '' : 'checked',
              'memberships-row-fields', 'not-fixed', 'mid-mid']">
              <img v-if="ele.content3 == 'check' || ele.content3 == 'x'"
                :src="ele.content3 == 'check' ? checkImg : xImg" />
            </div>
            <div :class="['memberships' + index,
            ele.content4 == 'x' ? '' : 'checked',
              'memberships-row-fields', 'not-fixed']">
              <img v-if="ele.content4 == 'check' || ele.content4 == 'x'"
                :src="ele.content4 == 'check' ? checkImg : xImg" />
            </div>
          </div>

          <div class="memberships-last-row">
            <div class="memberships-row-fields memberships-last-row-fields memberships-first-colum not-fixed">
              {{ fit20.blockToEdit.loop_content[fit20.blockToEdit.loop_content.length - 1].content1 }} </div>
            <div class="memberships-row-fields memberships-last-row-fields not-fixed memberships-btn-div"><a href="#"
                class="memberships-btn not-fixed">{{
                  fit20.blockToEdit.loop_content[fit20.blockToEdit.loop_content.length - 1].content2.try_free }}</a>
            </div>
          </div>
        </div>
        <div id="memberships-text" class="memberships-text-sec not-fixed">
          <div class="memberships-text1 not-fixed">{{ fit20.blockToEdit.text1 }}</div><br />
          <div class="memberships-text2 not-fixed">{{ fit20.blockToEdit.text2 }}</div>
        </div>
      </div>

      <br>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>
  </div>
</template>

<script>

export default {
  name: 'MemberShip',
  props: ["fit20", "saveBlock", "cancelEditing"],
  data() {
    return {
      checkImg: "https://www.fit20.com/files/images/Global/Global Extra/check.png",
      xImg: "https://www.fit20.com/files/images/Global/Global Extra/x.png",
    }
  }

};
</script>

<style scoped>
.membership {
  width: 100% !important;
}

.membership-textarea {
  height: 100px;
}

.yes-class {
  background-color: var(--fit20-green);
  color: white;
}

.no-class {
  background-color: var(--fit20-pink);
  color: white;
}

/* .membership .field-sec {
  width: 23%;
} */
.membership .field-sec:nth-child(1) {
  width: 40%;
}

.membership .field-sec:nth-child(n+2) {
  width: 20%;
}

.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/* example css */
.margin-top {
  margin-bottom: 20px;
}

.memberships-container {
  background-color: #616365 !important;
  padding: 30px 0 50px 0 !important;
}

#memberships_header {
  text-align: center;
  color: white !important;
  padding-bottom: 30px;
}

.memberships-sec {
  background-color: #ffffff !important;
  max-width: 1500px !important;
  width: 70% !important;
  max-width: 1000px !important;
  margin: auto !important;
  border-radius: 15px !important;
  padding: 20px 0;
}

.memberships-first-row-fields {
  font-size: 35px !important;
  font-family: 'VAG Rounded Std light', Verdana, Tahoma, sans-serif !important;
}

.membership-first-row-icons-sec {
  width: 100%;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  color: #009df4;
  font-size: 26px !important;
}

div.memberships-price.stronger {
  font-size: 20px !important;
  color: #616365 !important;
  padding-top: 5px;
  line-height: 30px;
}

div.memberships-price.stronger.usa-font-size {
  font-size: 16px !important;
  line-height: 25px;
}

.memberships-container .memberships-first-text {
  color: #616365ab !important;
  /* padding: 5px 0 !important; */
  font-size: 15px !important;
  padding-top: 40px !important;
  /* padding-bottom: 8px !important; */
}

.memberships-rows,
.memberships-first-row,
.memberships-last-row {
  display: flex !important;
  width: 100% !important;
  /* padding-bottom: 10px; */
  height: 70px;
}

.memberships-first-row {
  height: fit-content;
}

.memberships-last-row {
  margin-top: 30px;
}

.memberships-row-fields {
  width: calc(55% / 3) !important;
  min-height: 40px !important;
}

.memberships-btn-div {
  width: 55% !important;
  /* max-width: 175px !important; */
}

.memberships-first-colum,
.memberships-first-text {
  width: 45% !important;
  max-width: 430px !important;
  flex-direction: row-reverse;
  font-family: 'Open Sans', Arial, 'Helvetica Neue', Helvetica, sans-serif !important;
  color: #616365ab;
}

.memberships-first-colum:not(.memberships-first-text) {
  color: #009fe3 !important;
  font-size: 18px !important;
}

.mid-first {
  position: relative;
}

.mid-first div::before {
  content: '';
  border: 3px solid #009fe322;
  /* Specify the border properties as needed */
  border-radius: 30px;
  position: absolute;
  /* Position it absolutely relative to the parent */
  top: -10px;
  /* Adjust the top position */
  right: 0px;
  /* Adjust the right position */
  bottom: -440px;
  /* Adjust the bottom position */
  left: 0px;
  /* Adjust the left position */
}

.memberships-row-fields:not(.memberships-first-colum,
  .memberships-first-row-fields,
  .memberships-last-row-fields) {
  text-align: center !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.memberships-first-row-fields,
.memberships-last-row-fields {
  text-align: center !important;
  padding: 16px 0px !important;
}

.memberships-first-colum {
  display: flex !important;
  align-items: center !important;
  font-size: 14px !important;
  padding-left: 10px !important;
}

.memberships-row-fields img {
  width: 21px !important;
}

.checked img {
  width: 30px !important;
}

.memberships-last-row-fields {
  display: flex;
  justify-content: center;
  align-items: center;
}

a.memberships-btn,
a.memberships-btn:link,
a.memberships-btn:visited {
  cursor: pointer !important;
  color: white !important;
  background-color: #e5007d !important;
  border: solid 1px #e5007d !important;
  border-radius: 25px !important;
  padding: 8px 15px !important;
  transition: color 0.5s, background-color 0.5s !important;
  width: fit-content !important;
  text-decoration: none !important;
  font-size: 17px !important;
}

a.memberships-btn:hover {
  color: #e5007d !important;
  background-color: white !important;
}

a.memberships-read-more,
a.memberships-read-more:link,
a.memberships-read-more:visited {
  text-decoration: none !important;
  color: #009ff4 !important;
  font-size: 17px !important;
}

.membership-read-more-div {
  padding: 8px !important;
}

.memberships-text-sec {
  font-size: 15px !important;
  color: white !important;
  width: 65% !important;
  max-width: 1300px !important;
  margin: 0 auto !important;
  padding-top: 15px !important;
  line-height: normal;
}

@media only screen and (max-width: 1050px) {
  .memberships-sec {
    width: 85% !important;
  }
}

@media only screen and (max-width: 900px) {
  .memberships-sec {
    width: 95% !important;
  }

  .memberships-text-sec {
    font-size: 13px !important;
  }

  .memberships-first-row-fields {
    font-size: 25px !important;
  }

  .membership-first-row-icons-sec {
    font-size: 20px !important;
  }

  div.memberships-price.stronger {
    font-size: 15px !important;
    line-height: 15px;
  }

  div.memberships-price.stronger.usa-font-size {
    font-size: 15px !important;
    line-height: 15px;
  }

  .memberships-container .memberships-first-text {
    font-size: 13px !important;
    padding-top: 30px !important;
    line-height: 15px !important;
  }

  .memberships-first-colum:not(.memberships-first-text) {
    font-size: 15px !important;
  }
}

@media only screen and (max-width: 750px) {
  .memberships-container {
    padding: 50px 0 20px 0 !important;
  }

  .memberships-sec {
    width: 95% !important;
  }

  .memberships-first-row-fields {
    font-size: 12px !important;
  }

  div.memberships-price.stronger {
    font-size: 13px !important;
  }

  div.memberships-price.stronger.usa-font-size {
    font-size: 13px !important;
    line-height: 20px;
  }

  .memberships-rows,
  .memberships-first-row,
  .memberships-last-row {
    height: 55px;
  }

  .mid-first div::before {
    bottom: -270px;
    /* Adjust the bottom position */
  }

  .memberships-row-fields img {
    width: 18px !important;
  }

  .checked img {
    width: 27px !important;
  }

  a.memberships-btn,
  a.memberships-btn:link,
  a.memberships-btn:visited {
    border-radius: 20px !important;
    padding: 5px 10px !important;
    font-size: 12px !important;
  }

  a.memberships-read-more,
  a.memberships-read-more:link,
  a.memberships-read-more:visited {
    font-size: 13px !important;
  }

  .membership-read-more-div {
    padding: 5px !important;
  }

  .memberships-text-sec {
    font-size: 9px !important;
    padding-top: 10px !important;
  }
}

@media only screen and (max-width: 650px) {
  .mid-first div::before {
    bottom: -280px;
    /* Adjust the bottom position */
    border-radius: 15px;
  }

  .memberships-first-colum,
  .memberships-first-text {
    flex-direction: row;
  }

  .memberships-container .memberships-first-text {
    padding-top: 0px !important;
    line-height: 11px !important;
    font-size: 9px !important;
  }

  .memberships-row-fields.memberships-first-colum {
    line-height: normal !important;
  }
}
</style>
